// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkEvaluationCard-cls1_nVx","cls2":"WorkEvaluationCard-cls2_IAR WorkEvaluationCard-cls1_nVx"};